import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FindInspectionComponent } from './pages/find-inspection/find-inspection.component';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '../../translate';
import { MaterialModule } from '../../shared/material.module';
import { InspectionListTableComponent } from './components/inspection-list-table/inspection-list-table.component';
import { InspectionListRowComponent } from './components/inspection-list-row/inspection-list-row.component';
import { FindInspectionService } from './services/find-inspection.service';
import { RouterModule } from '@angular/router';
import { UnsyncedInspectionListTableComponent } from './components/unsynced-inspection-list-table/unsynced-inspection-list-table.component';
import { UnsyncedInspectionListRowComponent } from './components/unsynced-inspection-list-row/unsynced-inspection-list-row.component';
import { RepairEstimateListTableComponent } from './components/repair-estimate-list-table/repair-estimate-list-table.component';
import { RepairEstimateListRowComponent } from './components/repair-estimate-list-row/repair-estimate-list-row.component';
import { CreateNewInspectionComponent } from './create-new-inspection/create-new-inspection.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InspectionSortableTableComponent } from './components/inspection-sortable-table/inspection-sortable-table.component';
import { NewInspectionService } from './services/new-inspection.service';
import { FindInspectedEquipmentPopupComponent } from './create-new-inspection/find-inspected-equipment-popup/find-inspected-equipment-popup.component';
import { CreateNewWsreInspectionComponent } from './create-new-wsre-inspection/create-new-wsre-inspection.component';

import { InterpretationModule } from '../interpretation/interpretation.module';
import { InspectionSystemsComponent } from './create-new-inspection/inspection-systems/inspection-systems.component';
import { InspectionReviewComponent } from './create-new-inspection/inspection-review/inspection-review.component';
import { AddCommentOnComponentComponent } from './create-new-inspection/add-comment-on-component/add-comment-on-component.component';
import { AddInspectionObservationListsComponent } from './add-inspection-observation-lists/add-inspection-observation-lists.component';
import { ObservationListRowComponent } from './add-inspection-observation-lists/observation-list-row/observation-list-row.component';
import { NewObservationListPropertyComponent } from './add-inspection-observation-lists/new-observation-list-property/new-observation-list-property.component';
import { ManageInspectionTypeComponent } from './manage-inspection-type/manage-inspection-type.component';
import { SwapRollerModelComponent } from './create-new-inspection/swap-roller-model/swap-roller-model.component';
import {TemperatureListTableComponent} from './components/temperature-list-table/temperature-list-table.component';
import {TemperatureListRowComponent} from './components/temperature-list-row/temperature-list-row.component';
import { ThermographyListRowComponent } from './components/thermography-list-row/thermography-list-row.component';
import { ThermographyListTableComponent } from './components/thermography-list-table/thermography-list-table.component';
import { inspectioneventsComponent } from './pages/inspection-event/inspection-events.component';
import { InspectionApiComponent } from './pages/inspection-api/inspection-api.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule,
        MaterialModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        InterpretationModule,
    ],
    declarations: [
        FindInspectionComponent,
        InspectionListTableComponent,
        InspectionListRowComponent,
        UnsyncedInspectionListTableComponent,
        UnsyncedInspectionListRowComponent,
        RepairEstimateListTableComponent,
        RepairEstimateListRowComponent,
        CreateNewInspectionComponent,
        InspectionSortableTableComponent,
        FindInspectedEquipmentPopupComponent,
        CreateNewWsreInspectionComponent,
        InspectionSystemsComponent,
        InspectionReviewComponent,
        AddCommentOnComponentComponent,
        AddInspectionObservationListsComponent,
        ObservationListRowComponent,
        NewObservationListPropertyComponent,
        ManageInspectionTypeComponent,
        SwapRollerModelComponent,
        TemperatureListTableComponent,
        TemperatureListRowComponent,
        ThermographyListRowComponent,
        ThermographyListTableComponent,
        inspectioneventsComponent,
        InspectionApiComponent
    ],
    exports: [RouterModule],
    providers: [
        FindInspectionService,
        NewInspectionService
    ]
})
export class InspectionModule { }
